export const TID = {
    // auth
    loginEmail: "login-email-input",
    loginPassword: "login-password-input",
    loginSubmit: "login-submit-btn",
    logout: "logout-btn",
    themeToggle: "theme-toggle-btn",
    // sidebar
    navDashboard: "nav-dashboard",
    navCrm: "nav-crm",
    navPipeline: "nav-pipeline",
    navMarketing: "nav-marketing",
    navHealthCalendar: "nav-health-calendar",
    navNewsletter: "nav-newsletter",
    navAnalytics: "nav-analytics",
    navTasks: "nav-tasks",
    navAutomations: "nav-automations",
    navActions: "nav-actions",
    navAlerts: "nav-alerts",
    navContacts: "nav-contacts",
    navImport: "nav-import",
    // command palette
    searchOpen: "search-open-btn",
    searchInput: "universal-search-input",
    // AI chat
    aiChatOpen: "ai-chat-open-btn",
    aiChatInput: "ai-chat-input",
    aiChatSend: "ai-chat-send-btn",
    // Dashboard
    strategicPanel: "strategic-daily-panel",
    strategicRefresh: "strategic-refresh-btn",
    kpiCard: (name) => `kpi-${name}`,
    // CRM
    crmSearchInput: "crm-search-input",
    crmClientRow: (id) => `crm-row-${id}`,
    crmAddClient: "crm-add-client-btn",
    crmClientTab: (name) => `crm-tab-${name}`,
    // Pipeline
    pipelineColumn: (name) => `pipeline-col-${name}`,
    pipelineCard: (id) => `pipeline-card-${id}`,
    // Newsletter
    newsletterAdd: "newsletter-add-btn",
    // Health Calendar
    healthRecurrence: (id) => `health-rec-${id}`,
    healthGenerateCampaign: "health-generate-campaign-btn",
    // Actions
    actionRow: (id) => `action-row-${id}`,
    // Tasks
    tasksAdd: "task-add-btn",
};
